//@flow
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import TrekLists from '../TrekListings/TrekLists';
import { trekId } from '../../constants/idRegex';
import TrekOverview from './TrekOverview';
import TrekDayContainer from '../../redux/containers/TrekDayContainer';
import { PaymentSuccess } from '../../components';
import { GuidedReview, GuidedPayment } from './Guided';
import { SelfGuidedReview, SelfGuidedPayment, CustomerDetails } from './Self-Guided';

const baseRoute = `/treks/:trekName.:trekId(${trekId}).:regionName-region`;
const paymentSuffix = 'payment/:invoiceId';
const paymentSuccessSuffix = 'payment-success';

const TrekHome = () => (
  <Switch>
    <Route
      path={baseRoute}
      render={props => (
        <Switch>
          {/* GUIDED TREK */}
          <Route
            exact
            path={`${baseRoute}/review-guided-trek`}
            render={props => <GuidedReview trekId={props.match.params.trekId} />}
          />
          <Route
            exact
            path={`${baseRoute}/guided-trek/${paymentSuffix}`}
            component={GuidedPayment}
          />
          <Route
            exact
            path={`${baseRoute}/guided-trek/${paymentSuffix}/${paymentSuccessSuffix}`}
            component={PaymentSuccess}
          />

          {/* SELF-GUIDED TREK */}
          <Route
            exact
            path={`${baseRoute}/review`}
            render={props => <SelfGuidedReview trekId={props.match.params.trekId} />}
          />
          <Route
            exact
            path={`${baseRoute}/customer-details/:invoiceId`}
            component={CustomerDetails}
          />
          <Route
            exact
            path={`${baseRoute}/${paymentSuffix}`}
            component={SelfGuidedPayment}
          />
          <Route
            exact
            path={`${baseRoute}/${paymentSuffix}/${paymentSuccessSuffix}`}
            component={PaymentSuccess}
          />

          <Route
            exact
            path={`${baseRoute}/${paymentSuffix}`}
            component={SelfGuidedPayment}
          />

          <Route
            exact
            path={`${baseRoute}/day-:dayNumber`}
            render={({ match }) => (
              <TrekDayContainer
                id={match.params.trekId}
                day={match.params.dayNumber}
                url={props.match.url}
                name={match.params.trekName}
                region={match.params.regionName}
              />
            )}
          />
          <Route
            exact
            path={baseRoute}
            render={() => (
              <TrekOverview exact id={props.match.params.trekId} url={props.match.url} />
            )}
          />
        </Switch>
      )}
    />
    <Route component={TrekLists} />
  </Switch>
);

export default TrekHome;



// WEBPACK FOOTER //
// ./src/screens/Trek/TrekHome.js